function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { T, useTranslate } from 'shared/helper/translate';
import featureEnabled from 'shared/helper/feature';
import TranslationImage from '../images/language-duotone.svg';
import RubriqTranslationStatus from './RubriqTranslationStatus';
import WordAddinModal from './WordAddinModal';
var RubriqNoTranslationsMessage = function RubriqNoTranslationsMessage(_ref) {
  var _plans$premium$access, _plans$premium, _plans$preferred_grou, _plans$preferred_grou2, _plans$premium2, _plans$premium3, _plans$premium4, _plans$preferred_grou3, _plans$preferred_grou4;
  var onTranslateDocument = _ref.onTranslateDocument;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    wordAddinModalOpen = _useState2[0],
    setWordAddinModalOpen = _useState2[1];
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var _useSelector = useSelector(function (state) {
      return state;
    }),
    plans = _useSelector.curie.plans;
  var deepSeekEnabled = featureEnabled('rubriq_china_deep_seek');
  var premiumCount = (_plans$premium$access = plans === null || plans === void 0 || (_plans$premium = plans.premium) === null || _plans$premium === void 0 || (_plans$premium = _plans$premium.access) === null || _plans$premium === void 0 || (_plans$premium = _plans$premium.features) === null || _plans$premium === void 0 || (_plans$premium = _plans$premium.translation) === null || _plans$premium === void 0 ? void 0 : _plans$premium.usesRemaining) !== null && _plans$premium$access !== void 0 ? _plans$premium$access : 0;
  var preferredCount = (_plans$preferred_grou = plans === null || plans === void 0 || (_plans$preferred_grou2 = plans.preferred_group) === null || _plans$preferred_grou2 === void 0 || (_plans$preferred_grou2 = _plans$preferred_grou2.access) === null || _plans$preferred_grou2 === void 0 || (_plans$preferred_grou2 = _plans$preferred_grou2.features) === null || _plans$preferred_grou2 === void 0 || (_plans$preferred_grou2 = _plans$preferred_grou2.translation) === null || _plans$preferred_grou2 === void 0 ? void 0 : _plans$preferred_grou2.usesRemaining) !== null && _plans$preferred_grou !== void 0 ? _plans$preferred_grou : 0;
  var count = 0;
  if (plans !== null && plans !== void 0 && plans.premium && plans !== null && plans !== void 0 && plans.preferred_group) {
    count = premiumCount + preferredCount;
  } else if (plans !== null && plans !== void 0 && plans.premium) {
    count = premiumCount;
  } else {
    count = preferredCount;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column align-items-center gap-4 pt-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column align-items-center",
    style: {
      maxWidth: '400px'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: TranslationImage,
    alt: ""
  }), /*#__PURE__*/React.createElement("span", {
    className: "fw-semibold fs-4 mt-3"
  }, /*#__PURE__*/React.createElement(T, {
    source: "start your first translation"
  })), /*#__PURE__*/React.createElement("span", {
    className: "mt-2 text-center"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.no-translated-documents"
  })), /*#__PURE__*/React.createElement("button", {
    "aria-label": t('translate document'),
    type: "button",
    className: "not-global btn btn-primary mt-4 rounded-3",
    onClick: function onClick() {
      return onTranslateDocument();
    }
  }, /*#__PURE__*/React.createElement(T, {
    source: "translate document"
  })), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "not-global btn bg-white fw-bold rounded-2 px-3 text-nowrap d-flex align-items-center gap-2 rubriq-word-button rubriq-word-button-no-tanslation",
    onClick: function onClick() {
      return setWordAddinModalOpen(true);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "word-btn-icon"
  }, "W"), /*#__PURE__*/React.createElement(T, {
    source: "USE RUBRIQ IN WORD"
  }))), /*#__PURE__*/React.createElement(RubriqTranslationStatus, {
    isNoTranslationsMessage: true
  }), deepSeekEnabled && (plans === null || plans === void 0 || (_plans$premium2 = plans.premium) === null || _plans$premium2 === void 0 || (_plans$premium2 = _plans$premium2.access) === null || _plans$premium2 === void 0 || (_plans$premium2 = _plans$premium2.features) === null || _plans$premium2 === void 0 || (_plans$premium2 = _plans$premium2.translation) === null || _plans$premium2 === void 0 ? void 0 : _plans$premium2.feature) === 'translation' && (plans === null || plans === void 0 || (_plans$premium3 = plans.premium) === null || _plans$premium3 === void 0 ? void 0 : _plans$premium3.paymentStatus) !== 'trialing' && (plans === null || plans === void 0 || (_plans$premium4 = plans.premium) === null || _plans$premium4 === void 0 ? void 0 : _plans$premium4.trialGracePeriod) !== true || deepSeekEnabled && (plans === null || plans === void 0 || (_plans$preferred_grou3 = plans.preferred_group) === null || _plans$preferred_grou3 === void 0 || (_plans$preferred_grou3 = _plans$preferred_grou3.access) === null || _plans$preferred_grou3 === void 0 || (_plans$preferred_grou3 = _plans$preferred_grou3.features) === null || _plans$preferred_grou3 === void 0 || (_plans$preferred_grou3 = _plans$preferred_grou3.translation) === null || _plans$preferred_grou3 === void 0 ? void 0 : _plans$preferred_grou3.feature) === 'translation' && (plans === null || plans === void 0 || (_plans$preferred_grou4 = plans.preferred_group) === null || _plans$preferred_grou4 === void 0 ? void 0 : _plans$preferred_grou4.trialGracePeriod) !== true ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    style: {
      padding: '2px 4px 2px 4px',
      borderRadius: '5px',
      backgroundColor: '#f1f5f9'
    }
  }, /*#__PURE__*/React.createElement(T, {
    source: "deepseek-china-translation-info"
  })), /*#__PURE__*/React.createElement("span", {
    style: {
      padding: '2px 4px',
      borderRadius: '5px',
      backgroundColor: '#f1f5f9',
      marginLeft: '10px'
    }
  }, /*#__PURE__*/React.createElement(T, {
    source: "deepseek-other-translation-info",
    params: {
      count: count
    }
  }))) : '', /*#__PURE__*/React.createElement(WordAddinModal, {
    open: wordAddinModalOpen,
    onClose: function onClose() {
      return setWordAddinModalOpen(false);
    }
  }));
};
export default RubriqNoTranslationsMessage;